import React, { useState, useEffect } from 'react';
import { List } from '@material-ui/core';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import ReportListItem from './ReportListItem';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { useDispatch, useSelector } from 'react-redux';
import { buildFilters } from 'global/utils/filter';
import { get, set, size } from 'global/lib/lodash';
import ReportFab from 'feature/report/ReportFab';
import setFilter from 'redux/actions/setFilter';
import { useScreen } from 'global/styles';
import clsx from 'clsx';
import useStyles from './ReportList.styles';
import { Text } from 'global/components/text';
import ReportsFilters from 'feature/report/Filters';
import withSearchBar from 'global/components/withSearchBar';
import { FilterChips } from 'global/components/filterchips';
import moment from 'moment';

const AssessmentIncludes = ['realm', 'realm.parent', 'authors', 'lockedBy'];
const pageSize = 25;

export default function ReportList(props) {
  const include = AssessmentIncludes.join(',');
  const filter = useSelector((state) => get(state, 'filter.reports.list'));
  const realm = useSelector((state) => get(state, 'auth.realm.id'));
  const dispatch = useDispatch();
  const [hasChangedFilter, setHasChangedFilter] = useState(false);

  const filterProps = () =>
    buildFilters(filter, {
      includeRealm: true,
      convertName: {
        searchstring: ['realm_name', 'name'],
        realm_type: 'tier',
      },
      dontFilter: ['quality_type', 'superset_id', 'user_id', 'edition_id', 'status'],
      overrideFilter: (filt) => {
        if (filt.scorecard_id === 0) {
          delete filt.scorecard_id;
        }
        if (filt.vendor_id === 0) {
          delete filt.vendor_id;
        }
        if (filt.start_date) {
          if (!moment(filt.start_date).isValid()) {
            delete filt.start_date;
          }
        }
        if (filt.end_date) {
          if (!moment(filt.end_date).isValid()) {
            delete filt.end_date;
          }
        }
        return filt;
      },
    });

  const [urlParams, setUrlParams] = useState({
    build: ['assessments'],
    waitFor: null,
    params: {
      page: { size: pageSize, number: 1 },
      include,
      ...filterProps(),
    },
  });

  useEffect(() => {
    if (!hasChangedFilter && filter.searchstring) {
      setHasChangedFilter(true);
      dispatch(setFilter('reports', 'list', set({ ...filter }, '_sort.sortBy', 'name')));
    }
  }, [filter.searchstring]);

  useEffect(() => {
    setUrlParams({
      ...urlParams,
      waitFor: undefined,
      useEffect: true,
      params: {
        ...urlParams.params,
        ...{ page: { size: pageSize, number: 1 } },
        ...filterProps(),
      },
    });
  }, [filter, realm]);

  const { data: assessments, meta, loading, error } = useRetrieveData({ url: '/assessments' }, urlParams);

  const lastPage = get(meta, 'page.last-page', null);
  const updatePage = (newPage) => {
    if (newPage <= lastPage) {
      setUrlParams({
        ...urlParams,
        params: {
          ...urlParams.params,
          page: { size: pageSize, number: newPage },
        },
      });
    }
  };

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Header {...props} includeFab />
      <ListWithPages handlePageChange={updatePage} currentPage={get(urlParams, 'params.page.number', 1)} lastPage={lastPage} data={assessments} loading={loading} error={error} {...props} />
    </div>
  );
}

const ListWithPages = withSearchBar(withInfiniteScroll(ReportListItem, List));

export const Header = (props) => {
  const { includeFab } = props;
  const classes = useStyles();

  const { isMobile } = useScreen();

  const padLeft = get(props, 'padLeft', true);

  const title = get(props, 'title', 'Assessments');

  return (
    <div className={clsx(classes.row, padLeft && classes.padLeft)}>
      <div>
        <Text className={classes.marginBot} type={'headline_medium'}>
          {title}
        </Text>
        {isMobile ? <ReportsFilters {...props} /> : <FilterChips id={`reports.${props.display || 'list'}`} />}
        {props.children || null}
      </div>
      {includeFab && <ReportFab />}
    </div>
  );
};
